import Utils from "../../utils/Utils";

export default {

    init() {

        const DEBOUNCE_MILLIS = 5000;

        const ASTA = "asta";
        const CATALOGO = "catalogo";
        const VENDITA_DIRETTA = "vendita_diretta";

        const SINGOLO = "singolo";
        const COLLEZZIONE = "collezione";

        const INPUT_TYPE = "#input-type";

        const INPUT_COMMISSION = "#input-commission";

        const TABLE_PRODUCTS_SINGOLO = "#table-products-singolo";
        const TABLE_PRODUCTS_SINGOLO_BODY = "#table-products-singolo > tbody";
        const TABLE_PRODUCTS_COLLEZIONE = "#table-products-collezione";
        const TABLE_PRODUCTS_COLLEZIONE_BODY = "#table-products-collezione > tbody";

        const BTN_NUMBER_ALL = ".btn-number-all";
        const BTN_REMOVE_PRODUCT = ".btn-remove-product";
        const BTN_DETACH_PRODUCT = ".btn-detach-product";

        const INPUT_ORDER_EXTERNAL = ".tp-input-order-external";
        const INPUT_BASE = ".tp-input-base";
        const SPAN_BASE = ".tp-span-base";
        const INPUT_RETURN = ".tp-input-return";

        const DATA_PRODUCT_ID = "product-id";

        const ACCOUNTING_SINGLE = "#accounting-single";
        const ACCOUNTING_COLLECTION = "#accounting-collection";
        const ACCOUNTING_TOTAL = "#accounting-total";

        const TABLE_PRODUCTS_SINGLE_SORT_BY = "#table-products-single-sort-by";
        const TABLE_PRODUCTS_COLLECTION_SORT_BY = "#table-products-collection-sort-by"

        const TABLE_PRODUCTS_ROW_ACCOUNTING_SINGLE = "#table-products-row-accounting-single";
        const TABLE_PRODUCTS_ROW_ACCOUNTING_COLLECTION = "#table-products-row-accounting-collection";

        function getViewSelectedType() {
            return $(INPUT_TYPE).val();
        }

        function toggleInputCommission(type) {

            switch (type) {
                case ASTA:
                    $(INPUT_COMMISSION).attr('disabled', false);
                    break;
                default:
                    $(INPUT_COMMISSION).attr('disabled', true);
                    break
            }
        }

        $(INPUT_TYPE).change(function (e) {
            toggleInputCommission(getViewSelectedType());
        });

        toggleInputCommission(getViewSelectedType());


        let _sales_channel = null;

        function salesChannelLoaded(sales_channel) {
            _sales_channel = sales_channel;
            //loadSelectableProducts(_sales_channel.id);
            loadAssociatedProducts(_sales_channel.id, SINGOLO);
            loadAssociatedProducts(_sales_channel.id, COLLEZZIONE);
            loadAccounting(_sales_channel.id, SINGOLO);
            loadAccounting(_sales_channel.id, COLLEZZIONE);
            loadAccounting(_sales_channel.id);
            loadAccountingForTable(_sales_channel.id, SINGOLO);
            loadAccountingForTable(_sales_channel.id, COLLEZZIONE);
            $(PST_BTN_FILTER_SUBMIT).attr('disabled', false);
        }

        function loadSalesChannel(sales_channel_id) {

            httpRequest.get(`admin/content/api/sales-channels/${sales_channel_id}`)
                .then(response => salesChannelLoaded(response.data.data))
                .catch(error => {
                });
        }

        function accountingLoaded(accounting, type) {

            switch (type) {
                case SINGOLO:
                    $(ACCOUNTING_SINGLE).html(accounting);
                    break;
                case COLLEZZIONE:
                    $(ACCOUNTING_COLLECTION).html(accounting);
                    break;
                default:
                    $(ACCOUNTING_TOTAL).html(accounting);
                    break;
            }
        }

        function loadAccounting(sales_channel_id, type = "") {

            const params = {
                type: type,
                wants_html: true,
            };

            httpRequest.get(`admin/content/api/sales-channels/${sales_channel_id}/accounting`, {
                params: params,
            }).then(response => accountingLoaded(response.data.data, type))
                .catch(error => {
                })
        }

        function accountingForTableLoaded(accounting, type) {
            switch (type) {
                case SINGOLO:
                    $(TABLE_PRODUCTS_ROW_ACCOUNTING_SINGLE).html(accounting);
                    break;
                case COLLEZZIONE:
                    $(TABLE_PRODUCTS_ROW_ACCOUNTING_COLLECTION).html(accounting);
                    break;
            }
        }

        function loadAccountingForTable(sales_channel_id, type) {

            const params = {
                type: type,
                wants_html: true,
            };

            httpRequest.get(`admin/content/api/sales-channels/${sales_channel_id}/accounting-for-table`, {
                params: params
            }).then(response => accountingForTableLoaded(response.data.data, type))
                .catch(error => {
                });
        }

        loadSalesChannel(SALES_CHANNEL_ID);

        function associatedProductsLoaded(products, type) {

            switch (type) {
                case SINGOLO:
                    $(TABLE_PRODUCTS_SINGOLO_BODY).html(products);
                    break;
                case COLLEZZIONE:
                    $(TABLE_PRODUCTS_COLLEZIONE_BODY).html(products);
                    break;
            }

            const count_single = $(`${TABLE_PRODUCTS_SINGOLO_BODY} tr.product-row`).length;
            const count_collection = $(`${TABLE_PRODUCTS_COLLEZIONE_BODY} tr.product-row`).length;
            $("#single-total").text(count_single);
            $("#collection-total").text(count_collection);
            $("#count-total").text(count_single + count_collection);
        }

        function loadAssociatedProducts(sales_channel_id, type) {

            let sort_by = "order_internal";

            switch (type) {
                case SINGOLO:
                    sort_by = $(TABLE_PRODUCTS_SINGLE_SORT_BY).val();
                    break;
                case COLLEZZIONE:
                    sort_by = $(TABLE_PRODUCTS_COLLECTION_SORT_BY).val();
                    break;
            }

            const params = {
                type: type,
                wants_html: true,
                sort_by: sort_by,
            };

            httpRequest.get(`admin/content/api/sales-channels/${sales_channel_id}/associated-products`, {
                params: params,
            })
                .then(response => associatedProductsLoaded(response.data.data, type))
                .catch(error => {
                });
        }

        const PST = "#pst";
        const PST_BODY = "#pst > tbody";

        const PST_INPUT_SELECT_ALL_PRODUCTS = ".pst-input-select-all-products";
        const PST_INPUT_SELECT_PRODUCT = ".pst-input-select-product";
        const PST_BTN_INSERT_ALL_SELECTED_PRODUCTS = ".pst-btn-insert-all-selected-products";

        const PST_BTN_INSERT_PRODUCT = ".pst-btn-insert-product";

        const PST_INPUT_FILTER_PURCHASING_CHANNEL_TYPE = "#pst-input-filter-purchasing-channel-type";
        const PST_INPUT_FILTER_PRODUCT_TYPE = "#pst-input-filter-product-type";
        const PST_INPUT_FILTER_PRODUCT_CODE = "#pst-input-filter-product-code";
        const PST_INPUT_FILTER_PROTOCOL_NUMBER = "#pst-input-filter-protocol-number";
        const PST_INPUT_FILTER_PURCHASING_CHANNEL_ID = "#pst-input-filter-purchasing-channel-id";
        const PST_INPUT_FILTER_SALES_CHANNEL_ID = "#pst-input-filter-sales-channel-id";
        const PST_INPUT_FILTER_DESCRIPTION = "#pst-input-filter-description";
        const PST_INPUT_FILTER_NOTES = "#pst-input-filter-notes";
        const PST_BTN_FILTER_SUBMIT = "#pst-btn-filter-submit";


        function getPstFilterData() {

            return {
                purchasing_channel_type: $(PST_INPUT_FILTER_PURCHASING_CHANNEL_TYPE).val(),
                product_type: $(PST_INPUT_FILTER_PRODUCT_TYPE).val(),
                product_code: $(PST_INPUT_FILTER_PRODUCT_CODE).val(),
                protocol_number: $(PST_INPUT_FILTER_PROTOCOL_NUMBER).val(),
                purchasing_channel_id: $(PST_INPUT_FILTER_PURCHASING_CHANNEL_ID).val(),
                sales_channel_id: $(PST_INPUT_FILTER_SALES_CHANNEL_ID).val(),
                description: $(PST_INPUT_FILTER_DESCRIPTION).val(),
                notes: $(PST_INPUT_FILTER_NOTES).val(),
            }
        }

        function selectableProductsLoaded(selectable_products) {
            $(PST_BODY).html(selectable_products);
        }

        function loadSelectableProducts(sales_channel_id) {

            const params = getPstFilterData();
            params['wants_html'] = true;

            $(PST_BTN_FILTER_SUBMIT).prop('disabled', true);

            httpRequest.get(`admin/content/api/sales-channels/${sales_channel_id}/select-products`, {
                params: params,
            })
                .then(response => selectableProductsLoaded(response.data.data))
                .catch(error => {

                })
                .finally(function () {
                    $(PST_BTN_FILTER_SUBMIT).prop('disabled', false);
                });
        }

        $(PST_BTN_FILTER_SUBMIT).click(function (e) {
            e.preventDefault();

            //loadSalesChannel(_sales_channel.id);
            loadSelectableProducts(_sales_channel.id);
        });

        function insertProduct(sales_channel_id, product_id) {

            const data = {
                product_id: product_id,
            };

            httpRequest.post(`admin/content/api/sales-channels/${sales_channel_id}/insert-product`, data)
                .then(response => {
                    salesChannelLoaded(response.data.data);
                    $(PST_BODY).find(`tr[data-product-id=${product_id}]`).remove();
                });
        }

        function insertProducts(sales_channel_id, products) {

            const data = {
                products: products,
            };

            httpRequest.post(`admin/content/api/sales-channels/${sales_channel_id}/insert-products`, data)
                .then(response => {
                    salesChannelLoaded(response.data.data);
                    for (const product_id of products) {
                        $(PST_BODY).find(`tr[data-product-id=${product_id}]`).remove();
                    }

                });
        }

        $(PST).on('change', PST_INPUT_SELECT_ALL_PRODUCTS, function (e) {
            e.preventDefault();

            const checked = $(this).is(':checked');

            const pst_body_rows = $(PST_BODY).children();

            for (const row of pst_body_rows) {
                $(row).find(PST_INPUT_SELECT_PRODUCT).attr('checked', checked);
            }

        });

        $(PST).on('click', PST_BTN_INSERT_ALL_SELECTED_PRODUCTS, function (e) {

            const pst_body_rows = $(PST_BODY).children();

            const products = [];

            for (const row of pst_body_rows) {

                for (const input of $(row).find(PST_INPUT_SELECT_PRODUCT)) {

                    if ($(input).is(':checked')) {
                        const product_id = $(input).val();

                        if (!Utils.isEmpty(product_id)) {
                            products.push(product_id);
                        }
                    }
                }
            }

            if (products.length > 0) {
                insertProducts(_sales_channel.id, products);
            }
        });

        $(PST).on('click', PST_BTN_INSERT_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            insertProduct(_sales_channel.id, product_id);

            $(this).attr('disabled', true);
        });

        function associatedProductUpdated() {
        }

        function updateAssociatedProductOrderExternal(sales_channel_id, product_id, order_external, callback) {

            const data = {
                product_id: product_id,
                order_external: order_external,
            }

            httpRequest.put(`admin/content/api/sales-channels/${sales_channel_id}/update-associated-products-order-external`, data)
                .then(response => associatedProductUpdated())
                .catch(error => {
                })
                .finally(function (e) {
                    callback();
                })
        }

        function updateAssociatedProductBase(sales_channel_id, product_id, base, callback) {

            const data = {
                product_id: product_id,
                base: base,
            }

            httpRequest.put(`admin/content/api/sales-channels/${sales_channel_id}/update-associated-products-base`, data)
                .then(response => {
                    loadAccountingForTable(_sales_channel.id, SINGOLO);
                    loadAccountingForTable(_sales_channel.id, COLLEZZIONE);
                })
                .catch(error => {
                })
                .finally(function (e) {
                    callback();
                })
        }

        function setProductRetValAttribute(sales_channel_id, product_id, ret_val, callback) {

            const data = {
                sales_channel_id: sales_channel_id,
                ret_val: ret_val,
            }

            httpRequest.put(`admin/content/api/products/${product_id}/set-ret-val-attribute`, data)
                .then(response => {
                    const product = response.data.data;

                    if (product.type === SINGOLO) {

                        if (product.has_been_sold) {
                            $(`${TABLE_PRODUCTS_SINGOLO} tr[data-product-id=${product.id}]`).addClass('table-success');
                            $(`${TABLE_PRODUCTS_SINGOLO} ${BTN_REMOVE_PRODUCT}[data-product-id=${product.id}]`).addClass('d-none');
                            $(`${TABLE_PRODUCTS_SINGOLO} ${INPUT_BASE}[data-product-id=${product.id}]`).addClass('d-none');
                            $(`${TABLE_PRODUCTS_SINGOLO} ${SPAN_BASE}[data-product-id=${product.id}]`).removeClass('d-none');
                        } else {
                            $(`${TABLE_PRODUCTS_SINGOLO} tr[data-product-id=${product.id}]`).removeClass('table-success');
                            $(`${TABLE_PRODUCTS_SINGOLO} ${BTN_REMOVE_PRODUCT}[data-product-id=${product.id}]`).removeClass('d-none');
                            $(`${TABLE_PRODUCTS_SINGOLO} ${INPUT_BASE}[data-product-id=${product.id}]`).removeClass('d-none');
                            $(`${TABLE_PRODUCTS_SINGOLO} ${SPAN_BASE}[data-product-id=${product.id}]`).addClass('d-none');

                        }

                    } else {

                        if (product.has_been_sold) {
                            $(`${TABLE_PRODUCTS_COLLEZIONE} tr[data-product-id=${product.id}]`).addClass('table-success');
                            $(`${TABLE_PRODUCTS_COLLEZIONE} ${BTN_REMOVE_PRODUCT}[data-product-id=${product.id}]`).addClass('d-none');
                        } else {
                            $(`${TABLE_PRODUCTS_COLLEZIONE} tr[data-product-id=${product.id}]`).removeClass('table-success');
                            $(`${TABLE_PRODUCTS_COLLEZIONE} ${BTN_REMOVE_PRODUCT}[data-product-id=${product.id}]`).removeClass('d-none');
                        }
                    }

                    loadAccounting(_sales_channel.id, SINGOLO);
                    loadAccounting(_sales_channel.id, COLLEZZIONE);
                    loadAccounting(_sales_channel.id);
                    loadAccountingForTable(_sales_channel.id, SINGOLO);
                    loadAccountingForTable(_sales_channel.id, COLLEZZIONE);

                })
                .catch(error => {
                })
                .finally(function (e) {
                    callback();
                });
        }

        /**
         * HANDLER ORDINAMENTO ESTERNO TABELLA PRODOTTI SINGOLI
         */
        $(TABLE_PRODUCTS_SINGOLO).on('change', INPUT_ORDER_EXTERNAL, function (e) {
            const order_external = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_SINGOLO_BODY);
            table.sortable('disable');

            updateAssociatedProductOrderExternal(_sales_channel.id, product_id, order_external, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        });

        $(TABLE_PRODUCTS_SINGOLO).on('keyup', INPUT_ORDER_EXTERNAL, underscore.debounce(function (e) {
            const order_external = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_SINGOLO_BODY);
            table.sortable('disable');

            updateAssociatedProductOrderExternal(_sales_channel.id, product_id, order_external, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        }, DEBOUNCE_MILLIS));

        function numberProducts(sales_channel_id, type) {
            const config = {
                params: {
                    type: type,
                }
            };

            httpRequest.post(`admin/content/api/sales-channels/${sales_channel_id}/number-products`, {}, config)
                .then(response => salesChannelLoaded(response.data.data))
                .catch(error => {
                });
        }

        $(TABLE_PRODUCTS_SINGOLO).on('click', BTN_NUMBER_ALL, function (e) {
            e.preventDefault();
            numberProducts(_sales_channel.id, SINGOLO);
        });

        /**
         * HANDLER ORDINAMENTO ESTERNO TABELLA PRODOTTI COLLEZIONI
         */
        $(TABLE_PRODUCTS_COLLEZIONE).on('change', INPUT_ORDER_EXTERNAL, function (e) {
            const order_external = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_COLLEZIONE_BODY);
            table.sortable('disable');

            updateAssociatedProductOrderExternal(_sales_channel.id, product_id, order_external, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        });

        $(TABLE_PRODUCTS_COLLEZIONE).on('keyup', INPUT_ORDER_EXTERNAL, underscore.debounce(function (e) {
            const order_external = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_COLLEZIONE_BODY);
            table.sortable('disable');

            updateAssociatedProductOrderExternal(_sales_channel.id, product_id, order_external, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        }, DEBOUNCE_MILLIS));

        $(TABLE_PRODUCTS_COLLEZIONE).on('click', BTN_NUMBER_ALL, function (e) {
            e.preventDefault();
            numberProducts(_sales_channel.id, COLLEZZIONE);
        });

        /**
         * HANDLER BASE TABELLA PRODOTTI SINGOLI
         */
        $(TABLE_PRODUCTS_SINGOLO).on('change', INPUT_BASE, function (e) {
            const base = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_SINGOLO_BODY);
            table.sortable('disable');

            updateAssociatedProductBase(_sales_channel.id, product_id, base, function () {
                input.attr('disabled', false);
                table.sortable('enable');
                console.log(base);
                $(`${TABLE_PRODUCTS_SINGOLO} ${SPAN_BASE}[data-product-id=${product_id}]`).text(numeral(parseFloat(base)).format('0,0.00'));
            });

        });

        $(TABLE_PRODUCTS_SINGOLO).on('keyup', INPUT_BASE, underscore.debounce(function (e) {
            const base = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_SINGOLO_BODY);
            table.sortable('disable');

            updateAssociatedProductBase(_sales_channel.id, product_id, base, function () {
                input.attr('disabled', false);
                table.sortable('enable');
                console.log(base);
                $(`${TABLE_PRODUCTS_SINGOLO} ${SPAN_BASE}[data-product-id=${product_id}]`).text(numeral(parseFloat(base)).format('0,0.00'));
            });

        }, DEBOUNCE_MILLIS));

        /**
         * HANDLER BASE TABELLA PRODOTTI COLLEZIONI
         */
        $(TABLE_PRODUCTS_COLLEZIONE).on('change', INPUT_BASE, function (e) {
            const base = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_COLLEZIONE_BODY);
            table.sortable('disable');

            updateAssociatedProductBase(_sales_channel.id, product_id, base, function () {
                input.attr('disabled', false);
                table.sortable('enable');
                $(`${TABLE_PRODUCTS_COLLEZIONE} ${SPAN_BASE}[data-product-id=${product_id}]`).text(numeral(parseFloat(base)).format('0,0.00'));
            });

        });

        $(TABLE_PRODUCTS_COLLEZIONE).on('keyup', INPUT_BASE, underscore.debounce(function (e) {
            const base = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_COLLEZIONE_BODY);
            table.sortable('disable');

            updateAssociatedProductBase(_sales_channel.id, product_id, base, function () {
                input.attr('disabled', false);
                table.sortable('enable');
                $(`${TABLE_PRODUCTS_COLLEZIONE} ${SPAN_BASE}[data-product-id=${product_id}]`).text(numeral(parseFloat(base)).format('0,0.00'));
            });

        }, DEBOUNCE_MILLIS));

        /**
         * HANDLER RETURN TABELLA PRODOTTI SINGOLI
         */
        $(TABLE_PRODUCTS_SINGOLO).on('change', INPUT_RETURN, function (e) {
            const ret = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_SINGOLO_BODY);
            table.sortable('disable');

            setProductRetValAttribute(_sales_channel.id, product_id, ret, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        });

        $(TABLE_PRODUCTS_SINGOLO).on('keyup', INPUT_RETURN, underscore.debounce(function (e) {
            const ret = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_SINGOLO_BODY);
            table.sortable('disable');

            setProductRetValAttribute(_sales_channel.id, product_id, ret, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        }, DEBOUNCE_MILLIS));

        /**
         * HANDLER RETURN TABELLA PRODOTTI COLLEZIONI
         */
        $(TABLE_PRODUCTS_COLLEZIONE).on('change', INPUT_RETURN, function (e) {
            const ret = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_COLLEZIONE_BODY);
            table.sortable('disable');

            setProductRetValAttribute(_sales_channel.id, product_id, ret, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        });

        $(TABLE_PRODUCTS_COLLEZIONE).on('keyup', INPUT_RETURN, underscore.debounce(function (e) {
            const ret = $(this).val();
            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input = $(this);
            input.attr('disabled', true);

            const table = $(TABLE_PRODUCTS_COLLEZIONE_BODY);
            table.sortable('disable');

            setProductRetValAttribute(_sales_channel.id, product_id, ret, function () {
                input.attr('disabled', false);
                table.sortable('enable');
            });

        }, DEBOUNCE_MILLIS));

        function getTableOrder(e) {

            const order = [];

            const children = $(e.target).children();

            for (const child of children) {
                const product_id = $(child).data(DATA_PRODUCT_ID);

                if (!Utils.isEmpty(product_id)) {
                    order.push(product_id);
                }
            }

            return order;
        }

        function sortAssociatedProducts(e, ui) {

            const order = getTableOrder(e);

            const target = $(e.target);

            target.sortable('disable');

            const data = {
                products: order,
            };

            httpRequest.put(`admin/content/api/sales-channels/${_sales_channel.id}/sort-associated-products`, data)
                .then(response => salesChannelLoaded(response.data.data)).catch(error => {
                target.sortable('cancel');
            }).finally(function () {
                target.sortable('enable');
            });
        }

        function fixWidthHelper(e, ui) {

            ui.children().each(function () {
                $(this).width($(this).width());
            });

            return ui;
        }

        /**
         * HANDLER ORDINAMENTO PRODOTTO ASSOCIATI
         */
        $(TABLE_PRODUCTS_SINGOLO_BODY).sortable({
            helper: fixWidthHelper,
            stop: sortAssociatedProducts,
            handle: ".sort-handle",
        });

        $(TABLE_PRODUCTS_COLLEZIONE_BODY).sortable({
            helper: fixWidthHelper,
            stop: sortAssociatedProducts,
            handle: ".sort-handle",
        });

        $(TABLE_PRODUCTS_SINGLE_SORT_BY).change(function (e) {
            if (_sales_channel) {
                loadAssociatedProducts(_sales_channel.id, SINGOLO);
            }
        });

        $(TABLE_PRODUCTS_COLLECTION_SORT_BY).change(function (e) {
            if (_sales_channel) {
                loadAssociatedProducts(_sales_channel.id, COLLEZZIONE);
            }
        });

        function productRemoved() {
            loadAssociatedProducts(_sales_channel.id, SINGOLO);
            loadAssociatedProducts(_sales_channel.id, COLLEZZIONE);
            loadSelectableProducts(_sales_channel.id);
        }

        function removeProduct(sales_channel_id, product_id) {

            httpRequest.delete(`admin/content/api/sales-channels/${sales_channel_id}/${product_id}/remove-product`)
                .then(response => productRemoved())
                .catch(error => {
                });
        }

        function detachProduct(sales_channel_id, product_id) {

            httpRequest.post(`admin/content/api/sales-channels/${sales_channel_id}/${product_id}/detach-product`)
                .then(response => productRemoved())
                .catch(error => {
                });
        }

        $(TABLE_PRODUCTS_SINGOLO_BODY).on('click', BTN_REMOVE_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            if (!Utils.isEmpty(product_id) && confirm('Vuoi veramente elimnare l\'articolo selezionato dal canale di vendita?')) {
                removeProduct(_sales_channel.id, product_id);
            }
        });

        $(TABLE_PRODUCTS_COLLEZIONE_BODY).on('click', BTN_REMOVE_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            if (!Utils.isEmpty(product_id) && confirm('Vuoi veramente elimnare l\'articolo selezionato dal canale di vendita?')) {
                removeProduct(_sales_channel.id, product_id);
            }
        });

        $(TABLE_PRODUCTS_SINGOLO_BODY).on('click', BTN_DETACH_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            if (!Utils.isEmpty(product_id) && confirm('Vuoi veramente rimuovere l\'articolo selezionato dallo storico del canale di vendita?')) {
                detachProduct(_sales_channel.id, product_id);
            }
        });

        $(TABLE_PRODUCTS_COLLEZIONE_BODY).on('click', BTN_DETACH_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            if (!Utils.isEmpty(product_id) && confirm('Vuoi veramente rimuovere l\'articolo selezionato dallo storico del canale di vendita?')) {
                detachProduct(_sales_channel.id, product_id);
            }
        });

    },

    finalize() {

    },
}
